import { useQueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineGroupEventsApi } from '@/features/api/hooks/grapevine-group-events/useGrapevineGroupEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const useDenyPendingGroupJoinRequest = (groupId: string) => {
  const queryClient = useQueryClient();
  const api = useGrapevineGroupEventsApi();

  return useApiMutation({
    mutationFn: (personIdToDeny: string) =>
      api.denyPendingGroupJoinRequest({
        clientGroupPendingJoinDenyRequest: { groupId, personIdToDeny }
      }),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.PENDING_MEMBERS, groupId]
      })
  });
};
